import React, { useCallback } from 'react'
import { AutoComplete, AutoCompleteDataType, AutoCompleteProps } from 'scenes/Dashboard/components/Inputs/Select'
import { AutoCompleteOption } from 'scenes/Dashboard/components/Inputs/Select/AutoComplete/AutoComplete.model'
import { FieldProps, getIn } from 'utils-next/forms'

import { getUserName } from '../../../../../../../../../entities-next/user'

export type PersonSelectProps = Omit<AutoCompleteProps, 'value' | 'dataType' | 'onCreateOption' | 'onChange'> &
  FieldProps

export function PersonSelect({
  field: { name, value },
  form: { setFieldValue, errors },
  ...asyncSelectProps
}: PersonSelectProps) {
  const handleChange = useCallback(
    (autoCompleteOption: AutoCompleteOption | '') => {
      if (!autoCompleteOption) {
        setFieldValue(name, '')
        return
      }

      const {
        value,
        display: { label },
      } = autoCompleteOption
      setFieldValue(name, { id: value, name: label })
    },
    [name, setFieldValue]
  )

  const parsedValue = value ? { value, display: { label: value.name || getUserName(value) } } : ''

  return (
    <AutoComplete
      dataType={AutoCompleteDataType.person}
      onChange={handleChange}
      value={parsedValue}
      isClearable
      name={name}
      error={getIn(errors, name)}
      {...asyncSelectProps}
    />
  )
}
